export default __webpack_public_path__ + "static/progressive-mass-logo-48694f1da6be76049871b17018f2a8ef.png";